import Avatar from '@mui/material/Avatar';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { observer } from 'mobx-react-lite';
import { Icon } from '../../../../components/display';
import {
  FieldWrapper,
  type FieldWrapperProps,
  TextField,
} from '../../../../components/form';
import type Product from '../../../products/store/Product';
import type Products from '../../../products/store/Products';

export default observer(function ProductSelectList({
  label,
  onChange,
  productList,
  value,
  ...rest
}: ProductSelectListProps) {
  function onToggleItem(product: Product) {
    let newValue;

    // eslint-disable-next-line unicorn/prefer-ternary
    if (value.includes(product.id)) {
      newValue = value.filter((p) => p !== product.id);
    } else {
      newValue = [...value, product.id];
    }

    onChange(newValue);
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <FieldWrapper {...rest} label={label} sx={{ width: '100%' }}>
      <TextField
        onChange={(e) => productList?.setNameFilter(e.target.value)}
        placeholder="Filter by name…"
        size="small"
        startAdornment={<Icon icon="search" sx={{ mr: 0 }} />}
        sx={{ mt: 2 }}
        value={productList?.nameFilter || ''}
      />

      <List>
        {productList.filteredItems.map((product) => {
          const isChecked = value.includes(product.id);
          return (
            <ListItem
              button
              key={product.id}
              onClick={() => onToggleItem(product)}
            >
              <ListItemAvatar>
                <>
                  {product.coverUrl && (
                    <Avatar
                      alt={product.name}
                      src={product.coverUrl}
                      variant="rounded"
                    />
                  )}
                  {!product.coverUrl && (
                    <Avatar variant="rounded">
                      <Icon icon="cube" size="large" sx={{ mr: 0 }} />
                    </Avatar>
                  )}
                </>
              </ListItemAvatar>
              <ListItemText id={product.id} primary={product.name} />
              <ListItemSecondaryAction>
                <Checkbox
                  checked={isChecked}
                  edge="end"
                  inputProps={{ 'aria-labelledby': product.id }}
                  onChange={() => onToggleItem(product)}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </FieldWrapper>
  );
});

export interface ProductSelectListProps extends Omit<
  FieldWrapperProps,
  'onChange'
> {
  label?: string;
  onChange: (productIds: string[]) => void;
  productList: Products;
  value: string[];
}
